export type DiamondButtonShape = "dia-small" | "dia-big" | "box";
export type DiamondButtonFontSize = "normal" | "small" | "tiny";

export interface DiamondButtonOptions {
    container: HTMLElement;
    label?: string;
    visible?: boolean;
    className?: string;
    onClick?: (btn: DiamondButton, e: Event) => void;
    onVisibilityChange?: (visible: boolean) => void;
    shape?: DiamondButtonShape;
    filled?: boolean;
    fontSize?: DiamondButtonFontSize | "auto";
}

export class DiamondButton {


    public readonly onVisibilityChange = e5.Signal.create<[boolean]>();
    public readonly onClick = e5.Signal.create<[DiamondButton, Event]>();

    private _element: HTMLButtonElement;
    private _options: DiamondButtonOptions;

    constructor(options: DiamondButtonOptions) {
        options = e5.object.merge({
            container: null,
            visible: true,
            shape: "dia-big",
            fontSize: "auto",
            label: "",
            filled: true
        }, options);
        this._options = options;

        this._element = document.createElement("button");
        this._element.className = "diamond-button " + (options.className || "");
        this._element.innerHTML = `
        <div class="diamond-button__background"></div>
        <div class="diamond-button__label"></div>`;

        if (options.fontSize === "auto") {
            const hasMultiline = options.label.indexOf("\n") !== -1;
            const smallDiamond = options.shape === "dia-small";
            if (smallDiamond) {
                if (hasMultiline) {
                    options.fontSize = "tiny";
                } else {
                    options.fontSize = "tiny";
                }
            } else {
                if (hasMultiline) {
                    options.fontSize = "small";
                } else {
                    options.fontSize = "normal";
                }
            }
        }
        this.fontSize = options.fontSize;

        this.shape = options.shape;

        if (options.label) {
            this.label = options.label;
        }

        if (options.visible === false) {
            this.visible = false;
        }

        this.filled = options.filled;

        if (typeof options.onClick === "function") {
            this.onClick.add(options.onClick);
        }

        if (typeof options.onVisibilityChange === "function") {
            this.onVisibilityChange.add(options.onVisibilityChange);
        }

        this._element.addEventListener("click",
            (e) => {
                this.onClick.dispatch(this, e);
            }
        );

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get shape(): DiamondButtonShape {
        return this._element.getAttribute("data-shape") as DiamondButtonShape;
    }

    public set shape(value: DiamondButtonShape) {
        this._element.setAttribute("data-shape", value);
    }

    public get fontSize(): DiamondButtonFontSize {
        return this._element.getAttribute("data-font-size") as DiamondButtonFontSize;
    }

    public set fontSize(value: DiamondButtonFontSize) {
        this._element.setAttribute("data-font-size", value);
    }

    public get filled(): boolean {
        return this._element.classList.contains("diamond-button--filled");
    }

    public set filled(value: boolean) {
        this._element.classList.toggle("diamond-button--filled", value);
    }

    public get visible(): boolean {
        return !this._element.classList.contains("diamond-button--hidden");
    }

    public set visible(value: boolean) {
        if (this.visible === value) {
            return;
        }
        this._element.classList.toggle("diamond-button--hidden", !value);
        this.onVisibilityChange.dispatch(value);
    }

    public get label(): string {
        return this._element.querySelector(".diamond-button__label").textContent;
    }

    public set label(value: string) {
        this._element.querySelector(".diamond-button__label").textContent = value;
    }
}